import { __decorate } from "tslib";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { ApiApplicationStatusConstants } from "../../../shared/constants/api-constants/api-application-summary.constants";
import { ApiWorkflowConstants } from "src/app/shared/constants/api-constants/api-workflow.constants";
let DashboardService = class DashboardService {
    httpClient;
    filterApplicationBehaviour = new BehaviorSubject(null);
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getOverdueApplications(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_OVERDUE_APPLICATIONS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getLatestApplications(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        params = params.set("days", SharedConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_LATEST_APPLICATIONS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getTotalApplications(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        params = params.set("days", SharedConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_TOTAL_APPLICATIONS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getOpenedApplications(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        params = params.set("days", SharedConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_OPENED_APPLICATIONS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getClosedApplications(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        params = params.set("days", SharedConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_CLOSED_APPLICATIONS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getMultipleStatusCount(moduleIds) {
        let params = new HttpParams();
        params = params.append("moduleIds", moduleIds.join("|"));
        params = params.set("$select", `moduleId, statuses($top=${SharedConstants.DAYS_LIMIT})`);
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${ApiApplicationStatusConstants.FUNCTION_MULTIPLE_COUNT_STATUS}`, { params })
            .pipe(map((data) => {
            if (data !== undefined && data !== null && data.value !== undefined && data.value !== null) {
                return data.value;
            }
            else {
                return [];
            }
        }));
    }
    getWorkflowClosedStates() {
        return this.httpClient
            .get(`${ApiWorkflowConstants.URL}/${ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES}`);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
DashboardService = __decorate([
    Injectable({
        providedIn: "root",
    })
], DashboardService);
export { DashboardService };
